import * as React from 'react'
import { Link } from 'gatsby'
import {useTranslation} from 'gatsby-plugin-react-i18next';
import {generateUrl} from '../utils/generateUrl';


export const Header = ({ activeDocMeta }) => {
	const {t} = useTranslation();

	return (
		<div className="region region-header">
			<div className="c-main-navbar-container">
				<header id="header" className="c-main-navbar" role="banner">
					<nav className="c-main-navbar__skip-navigatie" aria-label="Skipnavigatie">
						<ul className="u-reset-list">
							<li className="u-m0">
								<a className="u-sr-only c-btn -secundary -small c-main-navbar__skip-link" href="#main-content">
									Ga naar de inhoud
								</a>
							</li>
						</ul>
					</nav>
					
					<nav className="o-stretch-wrapper u-bg-white" aria-label="Subnavigatie">
						<div className="o-wrapper u-p0 c-main-navbar__vlaanderen-header">
							<a href="https://www.vlaanderen.be/">
								<img src="/vlaanderen-logo.svg" alt="Naar vlaanderen.be" className="u-display-block" />
							</a>
						</div>
					</nav>

					<nav className="o-stretch-wrapper u-bg-blue-700">
						<div className="o-wrapper c-navbar-consultants">
							<nav className="c-navbar-consultants__wrapper" aria-label="VDAB navigatie">
								<a className="c-navbar-consultants__vdab-logo" href="https://www.vdab.be">
									<img src="/vdab-logo-white.svg" alt="Naar VDAB startpagina" />
								</a>
								<Link to={generateUrl(activeDocMeta.lang, '')} className="c-navbar-consultants__item-link u-p0 u-text-color-white">{t('siteName')}</Link>
							</nav>
						</div>
					</nav>
				</header>

			</div>
		</div>
	)
}
